export default function ArticleHeader({ headline }) {
  return (
    <h1 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 leading-tight">
      {headline}
    </h1>
  );
}
